import { render, staticRenderFns } from "./DomainListItem.vue?vue&type=template&id=cf391236&scoped=true"
import script from "./DomainListItem.vue?vue&type=script&lang=js"
export * from "./DomainListItem.vue?vue&type=script&lang=js"
import style0 from "./DomainListItem.vue?vue&type=style&index=0&id=cf391236&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf391236",
  null
  
)

export default component.exports